import { CircularProgress, Divider, Paper, Skeleton, Typography } from '@mui/material';

import styles from './ReportSkeleton.module.css';

/** Varied widths so the placeholder rows do not read as a solid block. */
const RAIL_LABEL_WIDTHS = [110, 150, 125, 85];
const CARD_ROW_WIDTHS = ['68%', '52%', '61%', '45%', '58%', '49%'];

/** One of the four cards in the report's 2x2 grid: heading and grand total, then table rows. */
function CardSkeleton() {
  return (
    <Paper
      variant='outlined'
      className={styles.card}>
      <div className={styles['card-title']}>
        <Skeleton
          variant='text'
          width={170}
          height={22}
        />
        <Skeleton
          variant='text'
          width={120}
          height={22}
        />
      </div>

      <div className={styles['card-body']}>
        {CARD_ROW_WIDTHS.map((width) => (
          <div
            key={width}
            className={styles.row}>
            <Skeleton
              variant='text'
              width={width}
            />
            <Skeleton
              variant='text'
              width={70}
            />
          </div>
        ))}
      </div>
    </Paper>
  );
}

/**
 * Loading placeholder shown while a settlement statement report is being initialized.
 * Mirrors the Summary tab's layout — a fixed rail beside a 2x2 card grid — so the real
 * content lands where the placeholder sat instead of shifting the page.
 */
export default function ReportSkeleton() {
  return (
    <div className={styles.skeleton}>
      <div
        className={styles.status}
        role='status'>
        <Paper
          variant='outlined'
          className={styles['status-pill']}>
          <CircularProgress size={20} />
          <Typography className={styles.message}>Initializing Report&hellip;</Typography>
        </Paper>
      </div>

      <div className={styles.layout}>
        <Paper
          variant='outlined'
          className={styles.rail}>
          <div className={styles['rail-rows']}>
            {RAIL_LABEL_WIDTHS.map((width) => (
              <div
                key={width}
                className={styles.row}>
                <Skeleton
                  variant='text'
                  width={width}
                />
                <Skeleton
                  variant='text'
                  width={80}
                />
              </div>
            ))}
          </div>

          <Divider />

          <div className={styles.row}>
            <Skeleton
              variant='text'
              width={95}
              height={28}
            />
            <Skeleton
              variant='text'
              width={115}
              height={28}
            />
          </div>

          <div className={styles.row}>
            <Skeleton
              variant='text'
              width={130}
              height={16}
            />
            <Skeleton
              variant='text'
              width={95}
              height={16}
            />
          </div>
        </Paper>

        <div className={styles['card-grid']}>
          <CardSkeleton />
          <CardSkeleton />
          <CardSkeleton />
          <CardSkeleton />
        </div>
      </div>
    </div>
  );
}
